import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import MultiSelectDropdown from '../../../../../../../../../../components/MultiSelectDropdown';
import {
  checkAllLinkedEntities,
  selectElementsToLinkToComment,
  updateLinkedEntities
} from '../../../../../../../../../../redux/modules/activityLog';

const ActivityLogMultiSelectWrapper = ({ title, checklist, type, minWidth }) => {
  const linkedEntities = useSelector(selectElementsToLinkToComment);
  const dispatch = useDispatch();

  const handleCheckAll = selectAll => {
    const entityLinkedItems = linkedEntities.filter(e => e.type === type);
    const checkedItems = (entityLinkedItems.length && !selectAll) ? [] : checklist;

    dispatch(checkAllLinkedEntities(checkedItems, type));
  };

  return (
    <Box>
      <MultiSelectDropdown
        selectAllOption
        data={checklist}
        displayLength={1}
        idKey="id"
        labelKey="description"
        minWidth={minWidth}
        placeholder={title}
        selectAllChange={selectAll => handleCheckAll(selectAll)}
        values={linkedEntities.filter(e => e.type === type)}
        onChange={selected => {
          dispatch(updateLinkedEntities(selected, type));
        }}
      />
    </Box>
  );
};

/** Wraps MultiSelectDropdown with ActivityLog-specific data and functionality */
ActivityLogMultiSelectWrapper.propTypes = {
  /** Title/placeholder that will show on the dropdown button while not active and above it while active */
  title: PropTypes.string,
  /** Data for dropdown menu */
  checklist: PropTypes.arrayOf(PropTypes.shape({})),
  /** Entity type of data being linked */
  type: PropTypes.string,
  /** Width for button and menu */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ActivityLogMultiSelectWrapper;
